import React, { Component } from 'react';
import { View, Image, StyleSheet } from 'react-native';

import { COLOR, THEME } from '../../../constants/styles';

import OPComponent from '../op_component';

export default class Check extends OPComponent {
  constructor(props) {
    super(props);
  }

  render() {
    let { checked, disabled, checkSize, iconStyle, iconType } = this.props;
    const largeSize = checkSize === 'large';
    iconType = !iconType || iconType === 'default' ? 'circle' : iconType;
    if (iconType === 'circle') {
      return (
        <View style={styles.container}>
          {!!checked ? (
            <Image
              style={[
                styles.iconButtonIcon,
                disabled ? styles.disabledIcon : {},
                largeSize ? styles.buttonSizeLarge : {},
                iconStyle,
              ]}
              source={require('../../../../resources/checked-circle.png')}
              resizeMode="contain"
            />
          ) : (
            <View
              style={[styles.uncheckedCircle, largeSize ? styles.buttonSizeLarge : {}, iconStyle]}
            />
          )}
        </View>
      );
    } else {
      return (
        <View style={[styles.box, checked ? styles.checked : null]}>
          {!!checked && (
            <Image
              style={styles.icon}
              source={require('../../../../resources/check.png')}
              resizeMode="contain"
            />
          )}
        </View>
      );
    }
  }
}

const styles = StyleSheet.create({
  container: {},
  iconButtonIcon: {
    width: 34,
    height: 34,
    // tintColor: COLOR.button,
  },
  uncheckedCircle: {
    width: 34,
    height: 34,
    borderColor: COLOR.textLight,
    borderRadius: 17,
    borderWidth: 1,
  },
  buttonSizeLarge: {
    width: 50,
    height: 50,
    borderRadius: 25,
  },
  disabledIcon: {
    tintColor: COLOR.textDisabled,
  },
  btnWithLabel: {
    flexDirection: 'row',
    marginBottom: 10,
  },
  box: {
    width: 22,
    height: 22,
    borderColor: '#777777',
    borderWidth: 1.5,
    borderRadius: 2,
    backgroundColor: 'white',
    justifyContent: 'center',
    alignItems: 'center',
  },
  checked: {
    borderColor: COLOR.button,
    backgroundColor: COLOR.button,
  },
  icon: {
    tintColor: 'white',
    width: 12,
    height: 12,
  },
});
